import { TextInput, Select } from "@mantine/core";
import styled from "@emotion/styled";
import tw from "twin.macro";
import { Theme } from "../context";

export const SelectInput = styled.div<{
  theme?: Theme;
  formbg?: string;
  formborder?: string;
  opacity?: number;
  formcolor?: string;
  isflex?: string;
}>`
  ${tw`flex items-center justify-start w-full px-4 my-2 text-base text-white rounded-full lg:my-10 font-clash outline-0`};
  ${({ theme }) =>
    theme === "dark" ? tw`font-medium text-white` : tw`font-medium `};
  background: ${({ theme, formbg }) =>
    theme === "dark"
      ? formbg || "transparent"
      : formbg
      ? "#F9F9F9"
      : "transparent"};
  border: ${({ theme, formborder }) =>
    formborder
      ? `1px solid ${formborder}`
      : theme === "dark"
      ? `1px solid  rgba(255, 255, 255, 0.5)`
      : `1px solid  rgba(30, 30, 30, 0.1)`};
  opacity: ${({ theme, opacity }) => (theme === "dark" ? opacity || 0.3 : 1)};
  color: ${({ theme, formcolor }) =>
    theme === "dark" ? formcolor || "white" : "#007fff;"};
  // padding: ${({ isflex }) => isflex && "26px !important"};
  // margin-top: ${({ isflex }) => isflex && "7px !important"};
`;

export const StyledTextInput = styled(TextInput)<{
  theme?: Theme;
  formbg?: string;
  formborder?: string;
  opacity?: number;
  formcolor?: string;
  isflex?: string;
}>`
  & .mantine-TextInput-wrapper {
    // ${tw`py-4 lg:py-10`}
  }
  & .mantine-TextInput-input {
    ${tw`w-full ml-2 text-base text-white rounded-full font-clash outline-0 py-7 md:py-8`};

    ${({ theme }) =>
      theme === "dark"
        ? tw`font-medium text-white`
        : tw`font-medium text-baseBlack`};
    background: ${({ theme, formbg }) =>
      theme === "dark"
        ? formbg || "transparent"
        : formbg
        ? "#F9F9F9"
        : "transparent"};
    border: ${({ theme, formborder }) =>
      formborder
        ? `1px solid ${formborder}`
        : theme === "dark"
        ? `1px solid  transparent`
        : `1px solid  transparent`};
    opacity: ${({ theme, opacity }) => (theme === "dark" ? opacity || 0.3 : 1)};
    color: ${({ theme, formcolor }) =>
      theme === "dark" ? formcolor || "white" : "#007fff;"};
    // padding: ${({ isflex }) => isflex && "26px !important"};
    // margin-top: ${({ isflex }) => isflex && "7px !important"};
  }

  & .mantine-TextInput-input:focus {
    ${tw`opacity-100`};
  }

  & .mantine-TextInput-input:focus::placeholder {
    ${tw`text-[0px] transition-all ease-in-out duration-500`};
  }

  & .mantine-TextInput-input::placeholder {
    ${tw`font-semibold`}
    ${({ theme }) =>
      theme === "dark"
        ? tw`font-medium text-gray-300`
        : tw`font-medium text-gray-700 opacity-70`}
  }

  & .mantine-TextInput-error {
    display: ${({ isflex }) => "none"};
  }

  & .mantine-TextInput-rightSection {
    background: green;
  }
  & .mantine-TextInput-required {
    color: blue;
  }
`;

export const StyledSelect = styled(Select)<{
  theme?: Theme;
  formbg?: string;
  opacity?: number;
  formcolor?: string;
  isflex?: string;
}>`
  & .mantine-Select-wrapper {
    // ${tw`my-4 lg:my-10`}
  }
  & .mantine-Select-input {
    ${tw`w-32 text-base rounded-none lg:w-40 font-clash outline-0 py-7 md:py-8`};

    ${({ theme }) =>
      theme === "dark"
        ? tw`font-medium text-red-200`
        : tw`font-medium text-baseBlack`};
    background: ${({ theme, formbg }) =>
      theme === "dark"
        ? formbg || "transparent"
        : formbg
        ? "#F9F9F9"
        : "transparent"};
    border: transparent;
    border-right: ${({ theme }) =>
      theme === "dark"
        ? `1px solid  rgba(255, 255, 255, 1)`
        : `1px solid  rgba(30, 30, 30, 0.1)`};
    opacity: ${({ theme, opacity }) => (theme === "dark" ? opacity || 0.3 : 1)};
    color: ${({ theme, formcolor }) =>
      theme === "dark" ? "white" : "#007fff;"};
    // padding: ${({ isflex }) => isflex && "26px !important"};
    // margin-top: ${({ isflex }) => isflex && "7px !important"};
  }

  & .mantine-Select-dropdown {
    ${tw`z-50`};
  }
  & .mantine-Select-input:focus {
    ${tw`opacity-100`};
  }

  & .mantine-Select-input:focus::placeholder {
    ${tw`text-[0px] transition-all ease-in-out duration-500`};
  }

  & .mantine-Select-input::placeholder {
    ${tw`font-semibold`}
    ${({ theme }) =>
      theme === "dark"
        ? tw`font-medium text-gray-300`
        : tw`font-medium text-gray-700 opacity-70`}
  }

  & .mantine-Select-error {
    display: ${({ isflex }) => "none"};
  }

  & .mantine-Select-rightSection {
    // background: green;
  }
  & .mantine-Select-required {
    color: blue;
  }
`;

export const FormController = styled.div`
  ${tw`pt-5 md:pt-0`}
`;

export const StyledForm = styled.form<{ isflex?: boolean }>`
  display: ${({ isflex }) => (isflex ? "flex" : "")};
  align-items: center;
  justify-content: center;
  gap: 5px;
  > div {
    width: ${({ isflex }) => isflex && "41%"};
  }

  > button {
  }

  @media screen and (max-width: 1024px) {
    > div {
      width: ${({ isflex }) => isflex && "60%"};
    }

    > button {
      width: ${({ isflex }) => isflex && "30%"};
    }
  }

  @media screen and (max-width: 500px) {
    display: block;

    > div {
      width: ${({ isflex }) => isflex && "100%"};
    }

    > button {
      width: ${({ isflex }) => isflex && "100%"};
    }
  }
`;

export const Error = styled.p`
  ${tw`font-[400] text-[14px] md:text-base text-right text-red-600`}
`;
